<template>
  <div class="d-flex justify-center line-liff">
    <div class="display-size base-brown">
      <RouterView></RouterView>
    </div>
  </div>
</template>

<script>
// custom css for line liff
import '@/styles/base.scss'

export default {
    name: 'MainLayout',
    components: {}
}
</script>
<style lang="scss" scoped>
#app {
  background: #cdcdcd;
}
.display-size {
  width: 100%;
  max-width: 500px;
  min-height: 100vh;
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075);
  // background: #fff;
}
</style>
